var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_29280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.746094 16.1749C2.44161 20.7445 6.84012 24.001 11.9997 24.001C17.1593 24.001 21.5578 20.7445 23.2533 16.1749L11.9997 15.1315L0.746094 16.1749Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 0.000732422C6.84012 0.000732422 2.44161 3.25723 0.746094 7.82684L11.9997 8.87028L23.2533 7.82679C21.5578 3.25723 17.1593 0.000732422 11.9997 0.000732422Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.746391 7.82581C0.264047 9.12579 0 10.5319 0 11.9997C0 13.4675 0.264047 14.8736 0.746391 16.1736H23.2537C23.736 14.8736 24 13.4675 24 11.9997C24 10.5319 23.736 9.12579 23.2536 7.82581H0.746391Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_29280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/DE.29e9296244b19b0648b123ceef2c4323.svg";
export { ForwardRef as ReactComponent };